module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd6606cf72c785d20950f52c20231eb98.d6606cf7.png";